'use client'
import React, { useCallback, useEffect, useMemo, useRef, useState, useTransition } from 'react'
import { ChevronRight, ChevronLeft } from 'lucide-react'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'

function FleetTabs({ isHideTabs = false, tabsAlignment = 'left', data, activeTab, setActiveTab }) {
  const t = useTranslations('all-fleet-types')
  const contentRef = useRef()
  const [horizontalScrollPercentage, setHorizontalScrollPercentage] =
    useState(0)
  const tabKeys = useMemo(() => Object.keys(data), [data]);
  const handelChangeActiveTab = useCallback((key, index) => {
    setActiveTab(prev => ({ ...prev, key, index }));
  }, [setActiveTab]);
  useEffect(() => {
    setHorizontalScrollPercentage(0)
  }, [])
  const handleScrollTabsContainer = (n) => {
    const tabsContainer = document.querySelector('#fleet-tabs-container')

    const scrollPercentage =
      (tabsContainer.scrollLeft /
        (tabsContainer.scrollWidth - tabsContainer.clientWidth)) *
      100

    setHorizontalScrollPercentage(Math.ceil(scrollPercentage))
    tabsContainer.scrollBy({
      left: n,
      behavior: 'smooth',
    })
  }
  return (
    !isHideTabs && (
      <div className={`flex items-center 
          ${tabsAlignment === 'left' ? 'justify-start' : 'justify-center'
        } 
        mb-7`}>
        <div
          className='cursor-pointer block lg:hidden'
          onClick={() => handleScrollTabsContainer(-60)}
        >
          <ChevronLeft
            color={`${horizontalScrollPercentage > 0
                ? 'fill-[black]'
                : 'fill-[#9e9e9e]'
              }`}
          />
        </div>
        <div
          ref={contentRef}
          id='fleet-tabs-container'
          style={{ overflowX: 'scroll' }}
          className='flex gap-5 max-w-full overflow-x-scroll  h-[28px]'
        >
          {tabKeys?.map((key, index) => (
            <button
              key={key}
              onClick={() => handelChangeActiveTab(key, index)}
              className={`relative ${key === 'Electric' ? 'hover:text-[#0ebb2b]' : ''
                } font-light outline-sky-400 text-nowrap transition ${activeTab.key === 'Electric' && key === 'Electric'
                  ? 'text-[#0ebb2b]'
                  : ''
                } ${activeTab.key === key ? ' font-normal' : ''}`}
            >
              {activeTab.key === key && (
                <motion.span
                  layoutId='underline'
                  className={`absolute inline-block uppercase left-0 w-full h-[2px] bottom-0 z-10 ${activeTab.key === 'Electric' ? 'bg-[#0ebb2b]' : 'bg-black'
                    } `}
                  // style={{ borderRadius: 9999 }}
                  transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                />
              )}
              {/* {t(key.toLowerCase())} */}
              {t.has(`${key?.toLocaleLowerCase()}`) ? t(`${key?.toLocaleLowerCase()}`) : key}
            </button>
          ))}
        </div>
        <div
          className='cursor-pointer block lg:hidden'
          onClick={() => handleScrollTabsContainer(60)}
        >
          <ChevronRight
            color={horizontalScrollPercentage >= 99 ? '#9e9e9e' : 'black'}
          />
        </div>
      </div>
    )
  )
}

export default FleetTabs